import { createFileRoute } from '@tanstack/react-router'

import { useFetchProject } from '@/modules/projects'
import { useFetchPortfolioLedger } from '@/modules/projects/components/portfolio/useFetchPortfolioLedger'
import { ProjectPortfolioPage } from '@/modules/projects/pages'

export const Route = createFileRoute(
  '/_authenticated/projects/$slug/portfolio',
)({
  component: ProjectPortfolio,
})

function ProjectPortfolio() {
  const { slug } = Route.useParams()
  // Load transactions so the nav's investment-account gate is right on a direct landing.
  useFetchProject(slug)
  useFetchPortfolioLedger(slug)

  return <ProjectPortfolioPage />
}
